// @flow

export { SafetypayCashForm } from './safetypay-cash-form';
